export enum TeamAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_TEAM_LIST = "UPDATE_TEAM_LIST",
    ADD_TEAM_LIST = "ADD_TEAM_LIST",
    UPDATE_TEAM_SEARCH_REQ = "UPDATE_TEAM_SEARCH_REQ",
    UPDATE_EMPLOYEE_LIST = "UPDATE_EMPLOYEE_LIST",
    UPDATE_OFFICE_LIST = "UPDATE_OFFICE_LIST",
    UPDATE_TEAM_TYPE_LIST = "UPDATE_TEAM_TYPE_LIST",
    SET_UPDATE_TEAM = "SET_UPDATE_TEAM",
}